<template lang="">
  <div class="bbs_filter">
    <div class="lft_area">
      <div class="bbs_info">
        <div class="total"><strong>{{ getCurrentCount() }}</strong> / {{ donationCategoryListCount }}</div>
      </div>
    </div>
    <div class="rgt_area">
      <div class="bbs_srch">
        <select name="" id="" class="i_sel" v-model="searchType">
          <option
            v-for="option in searchOptions"
            :value="option.value"
          >{{ option.name }}</option>
        </select>
        <input type="text" class="i_txt" name="keyword" v-model="searchWord">
        <button type="button" class="bt_base gray btn_srch" @click="getSearch">검색</button>
      </div>
    </div>
  </div>

  <div class="bbs_list">
    <table class="bbs_tbl">
      <colgroup>
        <col style="width:90px">
        <col style="width:30px">
        <col style="width:auto">
        <col style="width:auto">
        <col style="width:100px">
      </colgroup>
      <thead>
        <tr>
          <th scope="col">
            <span class="ui_chkbox primary nontxt">
              <input
                type="checkbox"
                @change="toggleAllCheck($event.target.checked)"
              >
              <label for=""></label>
            </span>
          </th>
          <th scope="col">번호</th>
          <th scope="col">기부처 명</th>
          <th scope="col">부모 카테고리</th>
          <th scope="col">사용여부</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(category, index) in donationCategoryList"
        >
          <td>
            <span class="ui_chkbox primary nontxt">
              <input
                type="checkbox"
                :value="category.seq"
                v-model="selectedCategories"
              >
              <label for=""></label>
            </span>
          </td>
          <td>{{ index + 1 }}</td>
          <td class="category"><a href="#none">{{ category.name }}</a></td>
          <td class="category">{{ category.parentName }}</td>
          <td>
            <select
              class="i_sel"
              style="width:88px"
              @change="changeUseYn(category)"
              v-model="category.isActive"
            >
              <option value="true">사용</option>
              <option value="false">미사용</option>
            </select>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="paginate">
    <AdminPagination
      :totalPages = "totalPages()"
      :currentPage = "currentPage"
      @changePage = "changePage"
    />

    <div class="rgt_area">
      <button type="button" class="bt_base primary large_h" @click="createCategory">기부처 등록</button>
      <button type="button" class="bt_base gray large_h" @click="deleteSelectedCategories">삭제</button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import AdminPagination from '@/components/common/AdminPagination.vue';

const adminDonationCategoryModule = 'adminDonationCategoryModule'

export default {
  components: {
    AdminPagination
  },

  data () {
    return {
      currentPage: 1,
      selectedCategories: [],

      searchOptions: [
        { name: '전체', value: 'all' },
        { name: '기부처명', value: 'category_name' },
        { name: '부모 카테고리명', value: 'parent_category_name' },
      ],
      searchType: '',
      searchWord: ''
    }
  },
  methods: {
    ...mapActions(adminDonationCategoryModule, [
      'requestCategoryList',
      'requestDeleteCategories',
      'requestChangeCategoryActivation'
    ]),

    createCategory () {
      this.$router.push({ name: "DonationCategoryManageCreatePage" })
    },

    totalPages() {
      return Math.ceil(this.donationCategoryListCount / 10);
    },

    async changePage(page) {
      this.currentPage = page
      const {currentPage, searchType, searchWord} = this
      await this.requestCategoryList({currentPage, searchType, searchWord})
    },

    getCurrentCount() {
      const currentFirstCount = (this.currentPage - 1) * 10 + 1
      let currentLastCount = this.currentPage * 10
      if (parseInt(currentLastCount) > parseInt(this.donationCategoryListCount)) {
        currentLastCount = this.donationCategoryListCount
      }
      return currentFirstCount + '-' + currentLastCount
    },

    toggleAllCheck(isChecked) {
      if (isChecked) {
        this.selectedCategories = []
        for (const category of this.donationCategoryList) {
          this.selectedCategories.push(category.seq)
        }
      } else {
        this.selectedCategories = []
      }
    },

    async deleteSelectedCategories() {
        if (this.selectedCategories.length === 0) {
            alert('선택된 기부처가 없습니다');
            return;
        }

        if (!confirm('삭제된 기부처는 복구할 수 없습니다.\n정말로 삭제하시겠습니까?')) {
            return;
        }

        const isSuccess = await this.requestDeleteCategories(this.selectedCategories);
        if (!isSuccess) {
            return;
        }

        this.selectedCategories = [];

        await this.requestCategoryList({
            currentPage: this.currentPage,
            searchType: this.searchType,
            searchWord: this.searchWord
        });

        if (this.donationCategoryList.length === 0 && this.currentPage > 1) {
            this.currentPage -= 1;

            await this.requestCategoryList({
                currentPage: this.currentPage,
                searchType: this.searchType,
                searchWord: this.searchWord
            });
        }
    },

    changeUseYn(category) {
      this.requestChangeCategoryActivation(category.seq)
    },

    async getSearch() {
      if (this.searchWord === '') {
        alert('검색어를 입력해주세요')
        return
      }
      this.currentPage = 1
      const {currentPage, searchType, searchWord} = this
      await this.requestCategoryList({currentPage, searchType, searchWord})
    }
  },

  computed: {
    ...mapState(adminDonationCategoryModule, [
      'donationCategoryList',
      'donationCategoryListCount'
    ])
  },

  async mounted() {
    const {currentPage, searchType, searchWord} = this
    await this.requestCategoryList({currentPage, searchType, searchWord})
    this.searchType = 'all'
  }
}
</script>
<style lang="">

</style>